import { Grid } from "@mui/material";
import React from "react";
// import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {latLngBounds} from 'leaflet';
import { MapContainer, TileLayer, Marker, Popup, Tooltip,CircleMarker, useMap, FeatureGroup } from 'react-leaflet'
import { FullscreenControl } from "react-leaflet-fullscreen";
import "react-leaflet-fullscreen/dist/styles.css";
import { Link } from "react-router-dom";

const ChangeView = (data) =>{
	const map = useMap();
	if(data?.markers?.length > 0){
		// map.setView({lng:data.center.lon, lat : data.center.lat}, 10);
		let markerBounds = latLngBounds([]);
		data?.markers?.forEach(marker => {
			markerBounds.extend([marker.lat, marker.lon])
		});
		map.fitBounds(markerBounds);
		map.scrollWheelZoom.enable()
	}
	return null
}


const DetailMap = (dataProps) => {
  let params = useParams();
	const getSubValue = (id,key) =>{
		let value = "";
		for(let i=0;i<dataProps?.dataSubArea?.length;i++){
			if(id === dataProps?.dataSubArea[i].id){
				value = dataProps?.dataSubArea[i][key]
			}
		}
		return value
	}
  const markers = []
	dataProps?.dataPengurusAll?.forEach((data)=>{
		markers.push({
			id_provinsi:data?.id_provinsi,
			nama_provinsi:data?.nama_provinsi,
			id_kabkot:data?.id_kabkot,
			nama_kab_kot:data?.nama_kab_kot,
			id_kecamatan:data?.id_kecamatan,
			nama_kecamatan:data?.nama_kecamatan,
			lat:data?.latitude,
			lon:data?.longitude,
			sk_pengurus:data?.info_dokumen?.dokumen_sk_pengurus,
			dokumen:data?.info_dokumen,
			jumlah_pengurus: (params?.tingkatExcoId === "2")? data?.jumlah_pengurus : (params?.tingkatExcoId === "3") ? data?.jumlah_pengurus_kabkot : data?.jumlah_pengurus_kecamatan,
			jumlah_pengurus_perempuan: (params?.tingkatExcoId === "2")? data?.jumlah_pengurus_perempuan : (params?.tingkatExcoId === "3") ? data?.jumlah_pengurus_kabkot_perempuan : data?.jumlah_pengurus_kecamatan_perempuan,
			jumlah_sub: (params?.tingkatExcoId === "2")? getSubValue(data?.id_provinsi,"id_sub") : (params?.tingkatExcoId === "3") ? getSubValue(data?.id_kabkot,"id_sub") : 0,
			jumlah_sub_ms: (params?.tingkatExcoId === "2")? getSubValue(data?.id_provinsi,"sub_ms") : (params?.tingkatExcoId === "3") ? getSubValue(data?.id_kabkot,"sub_ms") : 0,
			jumlah_sub_total: (params?.tingkatExcoId === "2")? getSubValue(data?.id_provinsi,"sub_total") : (params?.tingkatExcoId === "3") ? getSubValue(data?.id_kabkot,"sub_total") : 0,
		})
	})

	const persentase = (penyebut,pembagi) =>{
		let persen = 0
		if(parseInt(pembagi) !== 0 && parseInt(penyebut) !== 0){
			persen = ((parseInt(penyebut)/parseInt(pembagi))*100).toFixed(0)
		}
		return persen
	}

	const hasil = (data) =>{
    let result = "TMS"
    if(data.jumlah_pengurus > 0 && data?.sk_pengurus === 1 && parseFloat(persentase(data.jumlah_sub_ms,data.jumlah_sub))>=75){
      result = "MS"
    }
    return result
  }
	
	const center = {lat:-6.1754354, lon:106.8285582}
	return (
    <div>
      <MapContainer zoom={13} scrollWheelZoom={'true'}>
				<ChangeView center={center} markers={markers} />
        <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
				<FullscreenControl />
				<FeatureGroup >
					{markers.map((marker,index)=>{
						return (
							<CircleMarker
								center={[marker.lat, marker.lon]}
								pathOptions={
									(marker.sk_pengurus === 1 && marker.jumlah_pengurus > 0 &&  parseFloat(persentase(marker.jumlah_sub_ms,marker.jumlah_sub))>=75)?{ color: 'blue' }:
									(marker.sk_pengurus === 1 && marker.jumlah_pengurus > 0)?{ color: 'yellow' }:
									(parseFloat(persentase(marker.jumlah_sub_ms,marker.jumlah_sub))>=75)?{ color: 'orange' }:
									{ color: 'red' }
								}
								radius={10}
								key={index}
							>
								{(params?.tingkatExcoId === "2")?
									(
										<Popup>
											<div className="map-popup">
												<span>Provinsi : </span> <b>{marker.nama_provinsi}</b><br /><br/>

												Exco : <b>{(marker.sk_pengurus === 1 && marker.jumlah_pengurus > 0)? "Ada" : "Tidak Ada"}</b><br /><br />

												Jumlah Pengurus : <b>{marker.jumlah_pengurus}</b><br />
												Jumlah Pengurus Perempuan : <b>{marker.jumlah_pengurus_perempuan}</b><br />
												Persentase Pengurus Perempuan : <b>{persentase(marker.jumlah_pengurus_perempuan,marker.jumlah_pengurus)} %</b><br />
												<br/>
												Jumlah Exco Kab/Kota : <b>{marker.jumlah_sub_ms} ({persentase(marker.jumlah_sub_ms,marker.jumlah_sub)}%)</b><br />
												Jumlah Kab/Kota : <b>{marker.jumlah_sub}</b><br /><br/>
												Target Exco Kab/Kota (75%): <b>{Math.ceil(marker.jumlah_sub*0.75)}</b><br /><br/>
												Capaian Target : <b>{persentase(marker.jumlah_sub_ms,Math.ceil(marker.jumlah_sub*0.75))} %</b> ({((marker.jumlah_sub_ms-Math.ceil(marker.jumlah_sub*0.75)>0))?"+":""}{marker.jumlah_sub_ms-Math.ceil(marker.jumlah_sub*0.75)})<br/><br/>

												Hasil : <b>{hasil(marker)}</b>
												<br /><br/>
												<Grid container spacing={0}>
													<Grid item xs={6} sm={6} md={6}>
													</Grid>
													<Grid item xs={6} sm={6} md={6} style={{textAlign:'right'}}>
														<Link to={'/pengurus/3/'+marker.id_provinsi+'/0'}>
															<div style={{backgroundColor:'#f2f2f2', display:'inline-block', padding:'4px 8px', borderRadius:'4px'}}>
																Telusuri
															</div>
														</Link>
													</Grid>
												</Grid>
											</div>
										</Popup>
									)
									:null
								}
								{(params?.tingkatExcoId === "3")?
									(
										<Popup>
											<div className="map-popup">
												<span>Provinsi : </span> <b>{marker.nama_provinsi}</b><br />
												<span>Kab/Kota : </span> <b>{marker.nama_kab_kot}</b><br /><br/>

												Exco : <b>{(marker.sk_pengurus === 1 && marker.jumlah_pengurus > 0)? "Ada" : "Tidak Ada"}</b><br /><br />

												Jumlah Pengurus : <b>{marker.jumlah_pengurus}</b><br />
												Jumlah Pengurus Perempuan : <b>{marker.jumlah_pengurus_perempuan}</b><br />
												Persentase Pengurus Perempuan : <b>{persentase(marker.jumlah_pengurus_perempuan,marker.jumlah_pengurus)}%</b><br />
												<br/>
												Jumlah Exco Kecamatan : <b>{marker.jumlah_sub_ms} ({persentase(marker.jumlah_sub_ms,marker.jumlah_sub)}%)</b><br />
												Jumlah Kecamatan : <b>{marker.jumlah_sub}</b><br /><br />
												Target Exco Kab/Kota PB (75%): <b>{Math.ceil(marker.jumlah_sub*0.75)}</b><br />
												Standar Exco Kab/Kota KPU (50%): <b>{Math.ceil(marker.jumlah_sub*0.5)}</b><br /><br/>
												Capaian Target PB : <b>{persentase(marker.jumlah_sub_ms,Math.ceil(marker.jumlah_sub*0.75))}%</b> ({((marker.jumlah_sub_ms-Math.ceil(marker.jumlah_sub*0.75)>0))?"+":""}{marker.jumlah_sub_ms-Math.ceil(marker.jumlah_sub*0.75)})<br/>
												Capaian Standar KPU : <b>{persentase(marker.jumlah_sub_ms,Math.ceil(marker.jumlah_sub*0.5))}%</b> ({((marker.jumlah_sub_ms-Math.ceil(marker.jumlah_sub*0.50)>0))?"+":""}{marker.jumlah_sub_ms-Math.ceil(marker.jumlah_sub*0.50)})<br/><br/>

												Hasil : <b>{hasil(marker)}</b>
												<br /><br/>
												<Grid container spacing={0}>
													<Grid item xs={6} sm={6} md={6}>
														<Link to={'/pengurus/2/0/0'}>
															<div style={{backgroundColor:'#f2f2f2', display:'inline-block', padding:'4px 8px', borderRadius:'4px'}}>
																Kembali
															</div>
														</Link>
													</Grid>
													<Grid item xs={6} sm={6} md={6} style={{textAlign:'right'}}>
														<Link to={'/pengurus/4/'+marker.id_provinsi+'/'+marker.id_kabkot}>
															<div style={{backgroundColor:'#f2f2f2', display:'inline-block', padding:'4px 8px', borderRadius:'4px'}}>
																Telusuri
															</div>
														</Link>
													</Grid>
												</Grid>
											</div>
										</Popup>
									)
									:null
								}
								{(params?.tingkatExcoId === "4")?
									(
										<Popup>
											<div className="map-popup">
												<span>Provinsi : </span> <b>{marker.nama_provinsi}</b><br />
												<span>Kab/Kota : </span> <b>{marker.nama_kab_kot}</b><br />
												<span>Kecamatan : </span> <b>{marker.nama_kecamatan}</b><br /><br/>

												Exco : <b>{(marker.sk_pengurus === 1 && marker.jumlah_pengurus > 0)? "Ada" : "Tidak Ada"}</b><br /><br />

												Jumlah Pengurus : <b>{marker.jumlah_pengurus}</b><br />
												Jumlah Pengurus Perempuan : <b>{marker.jumlah_pengurus_perempuan}</b><br />
												Persentase Pengurus Perempuan : <b>{persentase(marker.jumlah_pengurus_perempuan,marker.jumlah_pengurus)} %</b>
												<br /><br/>
												<Grid container spacing={0}>
													<Grid item xs={6} sm={6} md={6}>
														<Link to={'/pengurus/3/'+marker.id_provinsi+'/0'}>
															<div style={{backgroundColor:'#f2f2f2', display:'inline-block', padding:'4px 8px', borderRadius:'4px'}}>
																Kembali
															</div>
														</Link>
													</Grid>
													<Grid item xs={6} sm={6} md={6} style={{textAlign:'right'}}>
													</Grid>
												</Grid>
											</div>
										</Popup>
									)
									:null
								}
							</CircleMarker>
						)
					})}
				</FeatureGroup>
    	</MapContainer>
			<div style={{
				position:"absolute", 
				backgroundColor:'rgba(255,255,255,0.4)',
				marginTop:'-105px',
				marginLeft:'10px',
				zIndex:1000
				}}>
				<table>
					<tbody>
						{(params?.tingkatExcoId !== "4")?
						<tr>
							<td><div style={{backgroundColor:'blue', width: '10px', height :'10px'}}></div></td>
							<td><span style={{fontSize:10}}>Memenuhi Syarat</span></td>
						</tr>
						:null}
						<tr>
							<td><div style={{backgroundColor:'yellow', width: '10px', height :'10px'}}></div></td>
							<td><span style={{fontSize:10}}>Keberadaan Exco Saja</span></td>
						</tr>
						{(params?.tingkatExcoId !== "4")?
						<tr>
							<td><div style={{backgroundColor:'orange', width: '10px', height :'10px'}}></div></td>
							<td><span style={{fontSize:10}}>Memenuhi Target PB Saja (Kepengurusan {(params?.tingkatExcoId === "2")?' Kab/Kota (75%)':' Kecamatan (75%)'})</span></td>
						</tr>
						:null}
						<tr>
							<td><div style={{backgroundColor:'red', width: '10px', height :'10px'}}></div></td>
							<td><span style={{fontSize:10}}>Tidak Memenuhi Syarat</span></td>
						</tr>
					</tbody>
				</table>
			</div>
    </div>
  );
};

export default DetailMap;
